<template>
  <div class="flex flex-center q-pa-lg">
    <q-form
      ref="validateForm"
      @submit="onSubmit"
      class="col-10"
      greedy
    >
      <div
        v-if="isAdding"
        class="text-center text-h5 q-pa-md"
      >
        Add Proxy Details
      </div>
      <div class="row items-start">
        <q-input
          :label="isAdding ? 'First Name: *' : 'First Name:'"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="proxyDetails.firstName"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          :rules="[checkInput]"
          lazy-rules
        />
      </div>
      <div class="row items-start">
        <q-input
          label="Middle Name:"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="proxyDetails.middleName"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          :rules="[alwaysTrue]"
        />
      </div>
      <div class="row items-start">
        <q-input
          :label="isAdding ? 'Last Name: *' : 'Last Name:'"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="proxyDetails.lastName"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          :rules="[checkInput]"
          lazy-rules
        />
      </div>
      <div class="row items-start">
          <q-input
            :label="isAdding ? 'Date of Birth: *' : 'Date of Birth:'"
            class="col-6"
            style="width: 200px"
            borderless
            readonly
          />
          <q-input
            v-if="!isEditing && !isAdding"
            v-model="proxyDetails.dateOfBirth"
            class="col-6"
            borderless
            readonly
            style="width: 250px"
            :rules="[alwaysTrue]"
            mask="####/##/##"
          />
          <q-input
            v-else
            class="col-6"
            style="width: 250px; margin-right: 40px"
            v-model="proxyDetails.dateOfBirth"
            :rules="[val => !!val || 'Please enter or select date of birth', checkIsValidDate]"
            lazy-rules
            mask="##/##/####"
          >
            <template v-slot:append>
              <q-icon
                name="event"
                class="cursor-pointer"
              >
                <q-popup-proxy
                  ref="qDateProxy"
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="proxyDetails.dateOfBirth"
                    mask="MM/DD/YYYY"
                    :rules="[val => !!val || 'Please enter date of birth', checkIsValidDate]"
                    lazy-rules
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Close"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
      </div>
      <div class="row items-start">
        <q-input
          :label="isAdding ? 'Mobile Phone: *' : 'Mobile Phone:'"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="proxyDetails.mobilePhone"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          mask="(###) ### - ####"
          unmasked-value
          :rules="[checkIsValidUsaPhone]"
          lazy-rules
        />
      </div>
      <div class="row items-start">
        <q-input
          :label="isAdding ? 'Permanent Phone: *' : 'Permanent Phone:'"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="proxyDetails.permanentPhone"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          mask="(###) ### - ####"
          unmasked-value
          :rules="[checkIsValidUsaPhone]"
          lazy-rules
        />
      </div>
      <div class="row items-start">
        <q-input
          :label="isAdding ? 'Email: *' : 'Email:'"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="proxyDetails.email"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          :rules="[checkIsValidEmail]"
          lazy-rules
        />
      </div>
      <div v-if="isEditing || isAdding" class="row items-start">
        <q-input
          :label="isAdding ? 'Confirm Email: *' : 'Confirm Email:'"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="confirmEmail"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          :rules="[val => confirmEmail == proxyDetails.email
            || 'Confirmation email does not match', checkIsValidEmail]"
          lazy-rules
        />
      </div>
      <div class="row items-start">
        <q-input
          :label="isAdding ? 'Relationship: *' : 'Relationship:'"
          style="width: 200px"
          borderless
          readonly
          class="col-6"
        />
        <q-input
          v-model="proxyDetails.relationship"
          style="width: 250px"
          :borderless = "!isEditing && !isAdding"
          :readonly = "!isEditing && !isAdding"
          class="col-6"
          :rules="[checkInput]"
          lazy-rules
        />
      </div>
      <q-btn
        v-if="isEditing"
        color="primary"
        label="Remove Above Proxy"
        @click="isProxyRemovalModalActive = true"
        flat
      />
    </q-form>
    <q-dialog
      ref="proxyRemovalModal"
      v-model="isProxyRemovalModalActive"
    >
      <q-card style="width: 550px; max-width: 80vw;">
        <div class="text-h6 text-center q-pa-lg">
        This will remove the proxy. Are you sure you would like to continue?
        </div>
        <br />
         <q-card-actions
          align="center"
          class="bg-white text-positive"
          >
          <q-btn
            flat
            color="positive"
            label="Cancel"
            @click="isProxyRemovalModalActive = false"
          />
          <q-btn
            color="primary"
            label="Remove"
            @click="isProxyRemovalModalActive = false; submitRemoveProxy()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useQuasar } from 'quasar';
import useUser from '@/hooks/user';
import useUiUtilities from '@/utilities/uiUtilities';
import useUiValidations from '@/utilities/uiValidations';

export default {
  props: {
    isAdding: Boolean,
    isEditing: Boolean,
    propProxyDetails: Object,
    userId: Number,
  },
  async setup(props) {
    const $q = useQuasar();
    const { addOrUpdateUserProxies } = useUser();
    const { notifyResult } = useUiUtilities();
    const {
      alwaysTrue,
      checkInput,
      checkIsValidDate,
      checkIsValidUsaPhone,
      checkIsValidEmail,
    } = useUiValidations();

    const proxyRemovalModal = ref(null);
    const proxyDetails = ref(props.propProxyDetails);
    if (!proxyDetails.value) {
      proxyDetails.value = {
        proxyId: 0,
        userId: props.userId,
        firstName: '',
        middleName: '',
        lastName: '',
        mobilePhone: '',
        permanentPhone: '',
        email: '',
        dateOfBirth: '',
        relationship: '',
        isSoftDeleted: false,
      };
    }

    const validateForm = ref(null);
    const confirmEmail = ref('');

    const onSubmit = async () => {
      const validationResult = await validateForm.value.validate();
      if (validationResult) {
        $q.loading.show();
        const listOfProxies = [proxyDetails.value];
        const response = await addOrUpdateUserProxies(listOfProxies);
        notifyResult(response.status, response);
        $q.loading.hide();

        return 200;
      }

      return 400;
    };

    const submitRemoveProxy = async () => {
      if (!proxyDetails.value.proxyId) {
        return;
      }
      proxyDetails.value.isSoftDeleted = true;
      $q.loading.show();
      const listOfProxies = [proxyDetails.value];
      const response = await addOrUpdateUserProxies(listOfProxies);
      notifyResult(response.status, response);
      $q.loading.hide();
      window.location.reload();
    };

    return {
      alwaysTrue,
      checkInput,
      checkIsValidDate,
      checkIsValidEmail,
      checkIsValidUsaPhone,
      confirmEmail,
      onSubmit,
      proxyDetails,
      proxyRemovalModal,
      submitRemoveProxy,
      validateForm,

      isProxyRemovalModalActive: ref(false),
    };
  },
};
</script>
